import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {EnvService} from "../services/env.service";
import {AuthService} from "../services/auth.service";
import {MicroSelectComponent} from "../shared/select/micro-select.component";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'micro-contactGroup-select',
  templateUrl: './contactGroup-select.component.html'
})
export class ContactGroupSelectComponent implements OnInit, OnChanges {
  @ViewChild("sel", {static: true}) sel: MicroSelectComponent;

  @Input() allLabel: string = 'All';
  @Input() allSelectOption: boolean = false;
  @Input() mode: string = 'simple';
  @Input() contactGroupId: any;
  @Output() contactGroupIdChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() value: any = '';
  @Input() companyId: any;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() sizeDynamically: boolean = false;
  @Input() jump: boolean = true;
  @Input() placeholder: string = 'Contact Group';

  options: any[] = [];
  private reloadDebouncer: EventEmitter<any> = new EventEmitter<any>();

  constructor(private auth: AuthService,
              private env: EnvService,
              private http: HttpClient) {
  }

  ngOnInit(): void {
    this.reloadDebouncer.pipe(debounceTime(10)).subscribe(change => this.reload());
    this.reloadDebounced();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['companyId']) {
      this.reloadDebounced();
    }
  }

  change(value: any) {
    this.contactGroupIdChange.emit(value);
    this.valueChange.emit(this.sel.getSelectedValue());
  }

  reloadDebounced() {
    this.reloadDebouncer.emit();
  }

  reload() {
    let activeCompanyId = this.defaultCompanyId() || this.companyId;
    let params = new HttpParams();
    if (activeCompanyId) {
      params = params.set("companyId", activeCompanyId);
    }
    this.sel.loading = true;
    this.http.get(`${this.env.e.url}/auth/contactGroups/all`, {params: params}).subscribe(
      data => {
        const options = data as any[];
        if (options.length && this.allSelectOption) {
          options.unshift({id: "--ALL--", name: this.allLabel});
        }
        this.options = options;
        this.sel.loading = false;
      }
    );
  }

  private defaultCompanyId(): string | undefined {
    if (this.auth.isCompanyAdmin() && this.auth.companyIdFilter) {
      return this.auth.companyIdFilter;
    }
    return undefined;
  }
}
